module.exports = __webpack_public_path__ + "static/relive_your_log-8fadef6376795afed7eedfef3f363b74.png";